import { Select } from 'antd';

const getMonthOptions = (months: string[]): React.ReactNode[] =>
  months.map((monthName, index) => (
    <Select.Option key={monthName} value={index}>
      {monthName}
    </Select.Option>
  ));

export { getMonthOptions };
